/* eslint-disable */

define([
  'vendor/jquery.validate.min.js',
  'app/control/uploader',
  'app/modules/language',
  'app/modules/forms',
  'app/modules/pdf_viewer',
  'app/modules/applicant',
  'app/modules/user',
  'vendor/countable.js',
  'app/modules/local_storage',
  'app/modules/utilities',
  'app/modules/applicant_upload_modal',
  'app/modules/employmentHistory',
  'app/modules/nestedFields',
  'app/modules/modals',
], (
  jquery_validate,
  Uploader,
  Language,
  Forms,
  PdfViewer,
  Applicant,
  User,
  Countable,
  LocalStorage,
  Util,
  ApplicantUploadModal,
  EmploymentHistory,
  NestedFields,
  Modals,
) => {
  class Interests {
    actionNew() {
      this.init();
    }

    actionStandalone() {
      this.init();
    }

    actionEdit() {
      this.init();
    }

    init() {
      LocalStorage.loadForm(
        'interest',
        $('.company-interest-form')
          .attr('action')
          .split('/')[2],
      );
      const uplPhoto = new Uploader($('#interest_user_photo'), { type: 'image' });
      const uplResume = new Uploader($('#interest_user_resume'), {
        type: 'file',
      });
      const form = $('form.company-interest-form');

      $('.add-language').on('click', (e) => {
        e.preventDefault();
        Language.add(null, 'interest');
      });

      $('.languages-list').on('click', '.remove-language', function (e) {
        e.preventDefault();
        Language.remove($(this));
      });

      form.on('submit', function (e) {
        e.preventDefault();
        if (!Modals.showDisclaimer()) {
          Forms.submitWithFiles($(this), 'interest_');
        }
      });

      $('#interest_email').on('input', function () {
        if (Util.validateEmail($(this).val())) Forms.checkEmailField($(this));
      });

      $('textarea[data-max-words]').each(function () {
        const txtArea = $(this);
        txtArea
          .parent()
          .find('.count_words')
          .html(txtArea.data('max-words'));

        Countable.live(this, function (ev) {
          const txtArea = $(this);


          const maxWord = $(this).data('max-words');

          if (ev.words > maxWord) {
            const arrVal =
              txtArea
                .val()
                .replace(/['";:,.?¿\-!¡]+/g, '')
                .match(/\S+/g) || [];
            txtArea.val(arrVal.slice(0, maxWord).join(' '));
          }

          const defWord = maxWord - ev.words;

          if (defWord < 0) {
            txtArea
              .parent()
              .find('.count_words')
              .css('display', 'none');
            txtArea
              .parent()
              .find('.warning_exceeding')
              .css('display', 'block');
          } else {
            txtArea
              .parent()
              .find('.count_words')
              .html(defWord)
              .css('display', 'block');
            txtArea
              .parent()
              .find('.warning_exceeding')
              .css('display', 'none');
          }
        });
      });

      form
        .find('.interest-position select#interest_position')
        .on('change', function () {
          if ($.inArray($(this).val(), ['intern', 'entry_level']) !== -1) {
            form
              .find('.job-type-fields .type-internship')
              .removeClass('hidden');
            form.find('.job-type-fields .type-experienced').addClass('hidden');
          } else if ($(this).val() == 'experienced') {
            form.find('.job-type-fields .type-internship').addClass('hidden');
            form
              .find('.job-type-fields .type-experienced')
              .removeClass('hidden');
          } else {
            form.find('.job-type-fields .type-internship').addClass('hidden');
            form.find('.job-type-fields .type-experienced').addClass('hidden');
          }
        });

      $('.modal#sign-in-modal form#new_user').on('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        User.signIn($(e.currentTarget), 'user_');
      });

      Forms.bindSharedControls();

      new EmploymentHistory({
        $container: $('.js-employments-fields'),
        resourceName: 'interest',
      });

      new NestedFields();

      Modals.initDisclaimer(() => { Forms.submitWithFiles(form, 'interest_'); });
    }

    actionCv_viewer() {
      const canvasContainer = document.getElementById('pdf-container');
      const url = canvasContainer.getAttribute('data-url');

      PdfViewer.renderPDF(url, canvasContainer);

      $('.zoom-in').on('click', (e) => {
        e.preventDefault();
        PdfViewer.zoomIn(canvasContainer);
      });

      $('.zoom-out').on('click', (e) => {
        e.preventDefault();
        PdfViewer.zoomOut(canvasContainer);
      });
    }

    actionIndex() {
      ApplicantUploadModal.init();
    }

    prepareThemes(themes, id, secondId = null) {
      themes = themes.filter(({ parent_id }) => parent_id === id || parent_id === secondId);

      return themes.map(theme =>
        Util.createElement('option', { value: theme.id }, theme.name));
    }

    actionCreate() {}
    actionUpdate() {}
  }

  return Interests;
});
